import Tooltip from '@mui/material/Tooltip'
import { Chip, Typography } from '@mui/material'
import useDate from '../../hooks/app/useDate'

const FormatDateRange = ({ startDate, endDate }) => {
  if (!startDate && !endDate) {
    return (  
    <Chip
      label="No date assigned" 
      variant="outlined"
    />)
  }

  const { determinateStatus, formatDate } = useDate()
  const status = determinateStatus(startDate, endDate)
  const start = formatDate(startDate)
  const end = formatDate(endDate)

  return (
    <>
      <Tooltip arrow placement='top' title={<span className='capitalize'>{status}</span>}>
        <Chip
          label={
            <Typography
              variant='inherit'
              className={[
                'capitalize',
                status === 'active' ? 'text-secondary font-bold' : ''
              ].join(' ')}
            >
              {start}{end ? ` - ${end}` : ''}
            </Typography>
          }
        />
      </Tooltip>
    </>
  )
}

export default FormatDateRange